import FeatureRouteGuard from "./FeatureRouteGuard";

const ScreeningRouteGuard = ({ children }: { children: React.ReactNode }) => (
  <FeatureRouteGuard flag="screening_enabled" permission="screening.view">
    {children}
  </FeatureRouteGuard>
);

export default ScreeningRouteGuard;
